import type { Theme } from '$lib/types'

export interface ThemeMeta {
  /** Persisted in Settings.theme. Must match the body class suffix. */
  id: Theme
  /** Body class name that applies the variable block in themes.css. */
  cls: string
  /** Display label for the toolbar button + tooltips. */
  label: string
  /** Single-glyph icon shown on the cycle button when this theme is active. */
  ico: string
}

/**
 * Canonical theme list, in cycle order. Header cycle button advances through
 * dark → light → dark-blue → light-blue → dark. Other UI (future settings
 * menu) can iterate this list.
 */
export const THEMES: readonly ThemeMeta[] = [
  { id: 'dark', cls: 'theme-dark', label: 'Dark', ico: '◐' },
  { id: 'light', cls: 'theme-light', label: 'Light', ico: '☀' },
  { id: 'dark-blue', cls: 'theme-dark-blue', label: 'Dark blue', ico: '◑' },
  { id: 'light-blue', cls: 'theme-light-blue', label: 'Light blue', ico: '☁' },
]

/** Look up the rich record for a theme id; falls back to the dark record. */
export function themeMeta(id: Theme): ThemeMeta {
  return THEMES.find((t) => t.id === id) ?? THEMES[0]
}

/** The theme that follows `id` in the canonical cycle. */
export function nextTheme(id: Theme): Theme {
  const idx = THEMES.findIndex((t) => t.id === id)
  // Unrecognised id (data corruption) falls back to dark by selecting index 0.
  const next = idx < 0 ? 0 : (idx + 1) % THEMES.length
  return THEMES[next].id
}
